export const capitalize = (value: string): string => (value ? value.charAt(0).toUpperCase() + value.slice(1) : '')
